import axios from "axios";
import { API_BASE_URL, getAuthToken } from "../artistStudio/shared";

// API helpers for Search and My Library (/v1/fan-discovery/...). Search works for guests; the library needs a sign-in.
const url = (path) => `${API_BASE_URL}/v1/fan-discovery/${path}`;
const config = (extra = {}) => {
  const token = getAuthToken();
  return { headers: { ...(token ? { token } : {}), "Content-Type": "application/json" }, timeout: 15000, ...extra };
};
const result = (response) => response.data?.result;

export const discoveryApi = {
  filters: () => axios.get(url("filters"), config()).then(result),
  search: (params = {}) => axios.get(url("search"), config({ params })).then(result),
  playlists: (params = {}) => axios.get(url("library/playlists"), config({ params })).then(result),
  playlist: (id) => axios.get(url(`library/playlists/${encodeURIComponent(id)}`), config()).then(result),
  licences: (params = {}) => axios.get(url("library/licences"), config({ params })).then(result),
  // Change the card that automatic renewal charges (a Stripe SetupIntent): start, then confirm once Stripe has the card.
  renewalCardStart: () => axios.post(`${API_BASE_URL}/v1/licence-payment/renewal-card/start`, {}, config()).then(result),
  renewalCardConfirm: (setupIntentId) => axios.post(`${API_BASE_URL}/v1/licence-payment/renewal-card/confirm`, { setup_intent_id: setupIntentId }, config()).then(result),
  setAutoRenew: (id, enabled) => axios.put(`${API_BASE_URL}/v1/licence-payment/auto-renew`, { entitlement_id: id, enabled }, config()).then(result),
  counts: () => axios.get(url("library/counts"), config()).then(result),
  createPlaylist: (name) => axios.post(url("library/playlists"), { name }, config()).then(result),
  renamePlaylist: (id, name) => axios.post(url(`library/playlists/${encodeURIComponent(id)}/rename`), { name }, config()).then(result),
  deletePlaylist: (id) => axios.post(url(`library/playlists/${encodeURIComponent(id)}/delete`), {}, config()).then(result),
  removePlaylistTrack: (id, trackId) => axios.post(url(`library/playlists/${encodeURIComponent(id)}/remove-track`), { track_id: trackId }, config()).then(result),
};
